import React from 'react';
import ReactDOM from 'react-dom';
import { SecureRoute } from '@okta/okta-react';
import App from './App';
import OktaAuth from './OktaAuth';

import './index.css';

ReactDOM.render(
  <OktaAuth>
    <SecureRoute path="/" component={App} />
  </OktaAuth>,
  document.getElementById('root'),
);
